import { ChevronRight, ChevronDown, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import FlagsCarousel from '../FlagsCarousel';

function HeroSection() {
  return (
    <section className="relative bg-gradient-to-br from-black via-[#0b1f33] to-[#1a3c55] text-white pt-[120px] pb-16 md:pt-[152px] md:pb-24 overflow-hidden">
      <div className="hero-pattern absolute inset-0" />
      <div className="container relative mx-auto px-4 flex flex-col md:flex-row items-center">
        <div className="w-full md:w-1/2 mb-10 md:mb-0 animate-fadeInLeft">
          <div className="eyebrow mb-5">Premium Airport Support Services</div>
          <h1 className="text-4xl md:text-5xl lg:text-[3.4rem] leading-[1.1] font-heading font-bold mb-6">
            SEAMLESS TRAVEL,
            <br />
            EXCEPTIONAL SERVICE
          </h1>
          <p className="text-lg text-white/80 mb-8 max-w-xl">
            Effortless <Link to="/services" className="text-[#73BDF2] hover:text-white underline underline-offset-4">airport</Link> experiences with <Link to="/services" className="text-[#73BDF2] hover:text-white underline underline-offset-4">premium travel and guest</Link> lounge, chauffeur, and{' '}
            <Link to="/services" className="text-[#73BDF2] hover:text-white underline underline-offset-4">baggage assistance</Link> services.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link to="/contact" className="btn-primary">
              Book Now <ChevronRight size={18} />
            </Link>
            <Link to="/services" className="btn-outline-light">
              Learn More <ChevronRight size={18} />
            </Link>
          </div>
          <div className="mt-14">
            <p className="mb-4 pb-1 text-xs font-heading font-semibold uppercase tracking-[0.2em] text-white/50">
              Present in 135+ Countries
            </p>
            <div className="hidden md:block max-w-lg">
              <FlagsCarousel />
            </div>
          </div>
        </div>
        <div className="md:w-1/2 relative animate-fadeInRight">
          <div className="relative z-10 aspect-[4/5] rounded-2xl overflow-hidden ring-1 ring-white/10 shadow-elevated bg-[#0b1f33]">
          <img
            src="https://images.unsplash.com/photo-1619659085779-29fcc0e41110?q=80&w=1470&auto=format&fit=crop"
            alt="Luxury private jet parked at an international airport during daytime"
            className="w-full h-full object-cover"
            loading="lazy"
          />
          </div>
          <div className="absolute top-1/2 right-0 transform translate-x-1/4 -translate-y-1/4 w-2/5 aspect-square rounded-2xl overflow-hidden ring-4 ring-black shadow-elevated hidden sm:block bg-[#0b1f33]">
            <img
              src="https://images.unsplash.com/photo-1521791055366-0d553872125f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1169&q=80"
              alt="Airport service"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="absolute -bottom-5 left-8 bg-white text-black rounded-xl shadow-elevated px-5 py-4 flex items-center gap-3 hidden sm:flex">
            <div className="flex text-yellow-400">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} size={14} fill="currentColor" strokeWidth={0} />
              ))}
            </div>
            <div className="text-xs">
              <p className="font-bold leading-none mb-0.5">2,000+</p>
              <p className="text-gray-500 leading-none">Satisfied Travelers</p>
            </div>
          </div>
        </div>
      </div>
      <div className="relative flex justify-center mt-14 md:mt-6">
        <div className="bg-[#73BDF2] rounded-full w-11 h-11 flex items-center justify-center shadow-glow-blue cursor-pointer hover:bg-[#5ba8e0] transition-colors duration-300">
          <ChevronDown size={22} className="text-white animate-bounce" />
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
